import { render, staticRenderFns } from "./SupportCulturalProgram.vue?vue&type=template&id=6b6c8920&"
import script from "./SupportCulturalProgram.vue?vue&type=script&lang=js&"
export * from "./SupportCulturalProgram.vue?vue&type=script&lang=js&"
import style0 from "./SupportCulturalProgram.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports